import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * Tab Portal component to render tabs.
 * @param {object} props The component props.
 * @param {object} props.children The children to render.
 * @returns {null|JSX.Element} The rendered TabPortal component.
 */
const BreadcrumbPortal = ({ children }) => {
  const tabRoot = document.getElementById('breadcrumb-buttons');
  if (tabRoot) {
    return ReactDOM.createPortal(children, tabRoot);
  }
  return null;
};

BreadcrumbPortal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BreadcrumbPortal;
